<div class="col-lg-6 col-xs-12">

    <div class="panel panel-default">
        <div class="panel-body">

<div style="display: block;">
        <canvas baseChart width="400" height="400"
                    [datasets]="lineChartData"
                    [labels]="lineChartLabels"
                    [options]="lineChartOptions"
                    [colors]="lineChartColors"
                    [legend]="lineChartLegend"
                    [chartType]="lineChartType"
                    (chartHover)="chartHovered($event)"
                    (chartClick)="chartClicked($event)"></canvas>
        </div>
      </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/report/charts/line-chart/line-chart.component.html